import styled from 'styled-components';
import { font } from 'nicollet-tokens';
import { Row } from '../../../Row/index.js';

const Option = styled(Row)`
  height: 100%;
  width: 100%;
  font-size: ${font.size.text.medium};
  ${({
  selected
}) => selected ? `
    font-weight: bold;
  ` : ''};
  &:hover {
    text-decoration: ${({
  disabled
}) => disabled ? 'none' : 'underline'};
  }
  margin-bottom: 0;
`;

export { Option };
